import { t } from '@sm/intl';
import COPY from '~pricing/copy';

export enum Packages {
  Basic = 'BASIC',
  StandardMonthly = 'STANDARD_MONTHLY',
  StandardAnnual = 'STANDARD_ANNUAL',
  AdvantageMonthly = 'ADVANTAGE_MONTHLY',
  AdvantageAnnual = 'ADVANTAGE_ANNUAL',
  PremierMonthly = 'PREMIER_MONTHLY',
  PremierAnnual = 'PREMIER_ANNUAL',
  TeamAdvantage = 'TEAM_ADVANTAGE_ANNUAL',
  TeamPremier = 'TEAM_PREMIER_ANNUAL',
  Enterprise = 'ENT_PLATINUM',
  Flex = 'ANALYZE_MONTHLY',
}

export const PackageIds: Record<Packages, number> = {
  [Packages.Basic]: 1,
  [Packages.StandardMonthly]: 31,
  [Packages.StandardAnnual]: 32,
  [Packages.AdvantageMonthly]: 33,
  [Packages.AdvantageAnnual]: 34,
  [Packages.PremierMonthly]: 35,
  [Packages.PremierAnnual]: 36,
  [Packages.TeamAdvantage]: 134,
  [Packages.TeamPremier]: 136,
  [Packages.Enterprise]: 26,
  [Packages.Flex]: 37,
};

export const ComparePlanIds: string[] = [
  Packages.Basic,
  Packages.StandardMonthly,
  Packages.StandardAnnual,
  Packages.AdvantageAnnual,
  Packages.PremierAnnual,
  Packages.TeamAdvantage,
  Packages.TeamPremier,
  Packages.Enterprise,
];

export enum LanguageCodes {
  PT = 'pt',
  EN = 'en-US',
  GB = 'en-GB',
  FR = 'fr',
  ES = 'es',
}

export enum SkuTypes {
  CoreSeat = 'SUBSCRIPTION_CORE_SEAT',
  AdditionalSeat = 'SUBSCRIPTION_ADDITIONAL_SEAT',
  ResponseOverage = 'RESPONSES',
}

export const PackageDisplayNames: Record<Packages, string> = {
  [Packages.Basic]: t(COPY.BASIC),
  [Packages.StandardMonthly]: t(COPY.STANDARD_MONTHLY),
  [Packages.StandardAnnual]: t(COPY.STANDARD_ANNUAL),
  [Packages.AdvantageMonthly]: t(COPY.ADVANTAGE_MONTHLY),
  [Packages.AdvantageAnnual]: t(COPY.ADVANTAGE_ANNUAL),
  [Packages.PremierMonthly]: t(COPY.PREMIER_MONTHLY),
  [Packages.PremierAnnual]: t(COPY.PREMIER_ANNUAL),
  [Packages.TeamAdvantage]: t(COPY.TEAM_ADVANTAGE),
  [Packages.TeamPremier]: t(COPY.TEAM_PREMIER),
  [Packages.Enterprise]: t(COPY.ENT_PLATINUM),
  [Packages.Flex]: t(COPY.FLEX),
};
